import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@services/api.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { DataHelper } from '@helpers/data.helper';
import { IsoCountriesPipe } from '@pipes/isoCountries.pipe';
import { UiHelper } from '@helpers/ui.helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { sportsSvgList } from '@app/constants/svgUrl.constant';
@Component({
  selector: 'all-sports-menu',
  templateUrl: '../sharedTemplates/all-sports-menu.html',
})
export class AllSportsMenu implements AfterViewInit, OnInit, OnDestroy {
  topCountries = [];
  public sportsSvgList = sportsSvgList;
  _dayFilter = 300;
  lastReturned_dayFilter = 0;
  selectedLeagueData = [];
  translator = new TranslatePipe(this._LocalizationService);
  private subscriptionsToStopOnDestroy: Subscription[] = [];
  constructor(
    private _ApiService: ApiService,
    private _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    public _Router: Router,
    public _UiHelper: UiHelper,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.leftMenuSportSelectedListener.subscribe(x => {
        const selectedSport = this._DataHelper.mainData.filter(s => s.SportId == x.sportId);
        if (selectedSport != undefined || selectedSport.length > 0) {
          this._DataHelper.selectedStorySportAllItem = selectedSport[0];

          this._DataHelper.selectedStorySportId = x.sportId;

          this.getCountriesBySportsID(this._DataHelper.selectedStorySportId, x.index);
        }
      }),
      this._DataHelper.LeagueDataListener.subscribe(x => {
        if (this._DataHelper.LeagueData != undefined) {
          this.selectedLeagueData = this._DataHelper.LeagueData;
        }
      }),
      this.route.params.subscribe(params => {
        if (params['id'] != undefined) {
          this._DataHelper.selectedStorySportId = params['id'];
          if (this._DataHelper.selectedStorySportId && this._DataHelper.selectedStoryIndex) {
            this.getCountriesBySportsID(this._DataHelper.selectedStorySportId, this._DataHelper.selectedStoryIndex);
          }
        }
      })
    );
  }
  ngOnDestroy(): void {
    for (let subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
  changeDayFilter(e) {
    if (e.value == undefined) {
      return;
    }

    this._DataHelper.leftMenuSportDayFilter = e.value;

    if (this._dayFilter != e.value) {
      e != undefined ? this.getSports(e.value) : null;
      this._dayFilter = e.value;
    }
  }

  changeTimeFilter(value) {
    this._DataHelper.leftMenuSportDayFilter = value;
    this._DataHelper.allSportsMenuSelectedTimeFilter = value;
    if (this._dayFilter != value) {
      this.getSports(value);
      this._dayFilter = value;
    }
  }
  openLeague(sport, tournament, category) {
    this.selectedLeagueData = [];

    const data = {
      TournamentName: tournament.TournamentName,
      TournamentId: tournament.TournamentId,
      CategoryId: tournament.CategoryId,
      CategoryName: category.CategoryName,
      SportId: sport.SportId,
      SportName: sport.SportName,
    };

    this.selectedLeagueData.push(data);

    this._DataHelper.setLeagueData(this.selectedLeagueData);

    this._DataHelper.setLeftMenuSportData(this._DataHelper.mainData, this._dayFilter);
    this._DataHelper.isOutRights = false;
  }

  openAll(e, category, sport, i, k) {
    this.selectedLeagueData = [];
    e.level.forEach(cb => {
      const cbData = {
        TournamentName: cb.TournamentName,
        TournamentId: cb.TournamentId,
        CategoryId: category.CategoryId,
        CategoryName: category.CategoryName,
        SportId: sport.SportId,
        SportName: sport.SportName,
      };

      this.selectedLeagueData.push(cbData);
      this._DataHelper.setLeagueData(this.selectedLeagueData);
      this._DataHelper.setLeftMenuSportData(this._DataHelper.mainData, this._dayFilter);
    });

    this.getTourementsByCountryID(sport.SportId, category.CategoryId, i, k);
  }

  getSports(__dayFilter = 300) {
    if (this.lastReturned_dayFilter != __dayFilter || this.lastReturned_dayFilter == 0) {
      this._ApiService.getSports(__dayFilter).then(x => {
        this._DataHelper.mainData = x.map(x => {
          x['level'] = [];
          x['loading'] = false;
          x['state'] = false;
          return x;
        });
        this.lastReturned_dayFilter = __dayFilter;
        this.getCountriesBySportsID(this._DataHelper.selectedStorySportId, this._DataHelper.selectedStoryIndex);
      });
    }
  }
  getCountriesBySportsIDB3000(selectedSport: any, index) {
    // this.allEventsCount = 0;
    this._DataHelper.selectedStorySportAllItem = selectedSport;
    this.getCountriesBySportsID(selectedSport.SportId, index);
  }
  getCountriesBySportsID(_sportID, _index) {
    this.topCountries = [];
    this._DataHelper.selectedStorySportId = _sportID;
    this._DataHelper.selectedStoryIndex = _index;
    this._DataHelper.mainData.forEach(element => {
      element['state'] = false;
    });

    this._ApiService.getCountriesBySportsID(this._dayFilter, _sportID).then((x: any) => {
      const countries = [];
      const headertop = {
        CategoryEventCount: 0,
        CategoryId: 0,
        CategoryName: this.translator.transform('topleagues', null),

        Ispopular: true,
        SportId: -99,
      };
      countries.push(headertop);
      const allEvents = {
        CategoryId: 0,
        CategoryName: this.translator.transform('ALLEVENT', null),
        Ispopular: true,
        SportId: -100,
        CategoryEventCount: 0,
      };
      countries.push(allEvents);
      const temptopcountries = x.filter(s => s.Ispopular);

      let PopulartotalCount = 0;
      temptopcountries.map(z => {
        const x = 0;
        PopulartotalCount += z['CategoryEventCount'];
        return x;
      });
      const json_temptopcountries = JSON.stringify(temptopcountries);
      countries.push(...JSON.parse(json_temptopcountries));

      const headerall = {
        CategoryEventCount: 0,
        CategoryId: 0,
        CategoryName: this.translator.transform('allLeagues', null),
        Ispopular: true,
        SportId: -99,
      };
      countries.push(headerall);
      countries.push(...x);
      let totalcount = 0;

      if (this._DataHelper.mainData[_index]) {
        this._DataHelper.mainData[_index].level = countries.map(a => {
          a['level'] = [];
          a['state'] = false;
          a['loading'] = false;
          a['allselected'] = false;
          totalcount += a['CategoryEventCount'];

          return a;
        });

        if (this._DataHelper.mainData[_index].level[1]) {
          this._DataHelper.mainData[_index].level[1].CategoryEventCount = totalcount - PopulartotalCount;
        }
        this._DataHelper.mainData[_index]['state'] = true;
      }
    });
    this._DataHelper.setLeftMenuSportData(this._DataHelper.mainData, this._dayFilter);
    this._DataHelper.mainData.map(item => {
      if (item.SportId == this._DataHelper.selectedStorySportId) {
        if (this._DataHelper.selectedStorySportAllItem != undefined) {
          this._DataHelper.selectedStorySportAllItem['SportName'] = item.SportName;
        } else {
          this._DataHelper.selectedStorySportAllItem = {
            OrginalName: 'Soccer',
            SportName: 'Soccer',
          };
        }
      }
    });
  }

  getTourementsByCountryID(_sportID, _countriesID, _index, _indexl2, menuId = '') {
    if (menuId != '') {
      const menu = menuId + _indexl2;
      this._UiHelper.allSportSelectedMenuId = menu;
    }

    const currentItem = this._DataHelper.mainData[_index].level[_indexl2];

    //////console.log(currentItem);
    //////console.log(currentItem.level.length == 0, !currentItem.state);
    if (currentItem.level.length == 0 && !currentItem.state) {
      currentItem['loading'] = true;
      this._ApiService
        .getTourementsByCountryID(this._dayFilter, _sportID, _countriesID)
        .then(x => {
          currentItem.level = x.map(x => {
            x['checked'] = false;
            return x;
          });
          currentItem['loading'] = false;
          currentItem['state'] = true;
          currentItem['allselected'] = false;
          // currentItem["_indexl2"] = _indexl2;

          this._ApiService.getOutrightsByCountryID(this._dayFilter, _sportID, _countriesID).then(x => {
            currentItem.outrights = x.map(x => {
              x['checked'] = false;
              return x;
            });
          });
        })
        .catch(err => {
          console.log('all-sports-menu', err);
        });
    } else if (currentItem.level.length != 0 && !currentItem.state) {
      currentItem['state'] = true;
    } else {
      currentItem['state'] = false;
    }
    this._DataHelper.mainData[_index].level[_indexl2] = currentItem;
    //////console.log(this.this._DataHelper.mainData);
    this._DataHelper.setLeftMenuSportData(this._DataHelper.mainData, this._dayFilter);
  }

  ngAfterViewInit() {
    if (this._DataHelper.allSportsMenuSelectedTimeFilter != 0 && this._DataHelper.allSportsMenuSelectedTimeFilter != undefined) {
      this._dayFilter = this._DataHelper.allSportsMenuSelectedTimeFilter;
    }

    if (this._UiHelper.allSportSelectedMenuId != '') {
      setTimeout(() => {
        this._UiHelper.ScrollToId();
      }, 100);
    }
  }

  ngOnInit() {
    if (this._DataHelper.mainData == undefined || this._DataHelper.mainData.length == 0) {
      this.getSports();
    }
    this.changeDayFilter({ source: null, value: '300' });
  }

  add2TournamentFavs(tour, cat) {
    const favitem = {
      tourid: tour.TournamentId,
      tourname: tour.TournamentName,
      catid: cat.CategoryId,
      catname: cat.CategoryName,
      count: tour.TournamentSportEventCount,
    };
    tour['checked'] = !tour['checked'];
    this._UiHelper.favTournamentChanged(favitem);
  }
  onClickAllEvent() {
    this.selectedLeagueData = [];
    if (this._DataHelper.selectedStorySportAllItem) {
      const data = {
        TournamentName: '',
        TournamentId: '',
        CategoryId: 0,
        CategoryName: this.translator.transform('ALLEVENT', null),
        SportId: -100,
        SportName: this._DataHelper.selectedStorySportAllItem.SportName,
      };
      this.selectedLeagueData.push(data);

      this._DataHelper.setLeagueData(this.selectedLeagueData);

      this._Router.navigate(['/allevents'], {
        queryParams: {
          MenuId: this._DataHelper.selectedStorySportId,
          TimeRangeId: this._dayFilter,
        },
      });
    }
  }
}
